import moment from 'moment'
import oss from 'ali-oss'
export const setDate = date => {
  if (date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  } else {
    return ''
  }
}

export const filteYearMonthDate = date => {
  if (date) {
    return moment(date).format('YYYY-MM-DD')
  } else {
    return ''
  }
}

// 一般状态
export const filteStatus = (status, key) => {
  const statusList = {
    0: { name: 'public.close', color: '#f50' },
    1: { name: 'public.open', color: 'green' }
  }
  const returnStatus = statusList[status] || {}
  return returnStatus[key] || ''
}

// 性别
export const filteGender = (gender, key) => {
  const genderList = {
    male: {
      name: '男',
      color: '#1890ff',
      icon: 'man',
      translate: 'public.male'
    },
    female: {
      name: '女',
      color: '#eb2f96',
      icon: 'woman',
      translate: 'public.female'
    }
  }
  const returnGender = genderList[gender] || {}

  return returnGender[key]
}

// 学籍状态
export const filteEnrollment = (enrollmentType, key) => {
  const enrollmentList = {
    1: { label: 'public.active', value: 1 },
    2: { label: 'public.graduation', value: 2 },
    3: { label: 'public.suspending', value: 3 },
    4: { label: 'public.dropout', value: 4 },
    9: { label: 'public.pre10', value: 9 },
    10: { label: 'public.10', value: 10 },
    11: { label: 'public.11', value: 11 }
  }
  const returnGender = enrollmentList[enrollmentType] || {}
  return returnGender[key] || ''
}
export default {
  AliyunUpload: async function (configData, filename, fileObject, callback) {
    let multipartUploadP = new Promise(resolve => {
      var client = new oss({
        accessKeyId: configData.accessKeyId,
        accessKeySecret: configData.accessKeySecret,
        bucket: configData.bucket,
        region: configData.region
      })
      const progress = (p, _checkpoint) => {
        // console.log(p) // Object的上传进度。
        // console.log(_checkpoint) // 分片上传的断点信息。
        if (callback) {

          callback(p)
        }
      }
      async function multipartUpload() {
        try {
          // object-name可以自定义为文件名（例如file.txt）或目录（例如abc/test/file.txt）的形式，实现将文件上传至当前Bucket或Bucket下的指定目录。
          const result = await client.multipartUpload(filename, fileObject, {
            progress,
            // meta是用户自定义的元数据，通过head接口可以获取到Object的meta数据。
            meta: {
              year: 2020,
              people: 'test'
            }
          })
          // console.log(result)
          const head = await client.head(filename)
          resolve(head)
        } catch (e) {
          // 捕获超时异常。
          if (e.code === 'ConnectionTimeoutError') {
            console.log('TimeoutError')
            // do ConnectionTimeoutError operation
          }
          console.log(e)
        }
      }
      multipartUpload()
    })
    let uploadImg = await multipartUploadP
    return uploadImg
  }
}
